import { FC } from 'react';

import Badge from '../Badge';
import ChevronDownIcon from './assets/chevron-down.svg';
import {
  StyledBadgeWrapper,
  StyledIconWrapper,
  StyledTriggerButton,
  StyledTriggerButtonChevron,
  StyledTriggerButtonValue,
  StyledValueText,
} from './Select.styled';
import type { SelectTriggerButtonProps } from './types';

const SelectTriggerButton: FC<SelectTriggerButtonProps> = ({
  label,
  count = 0,
  onClick,
  open,
  size = 'lg',
  state = 'default',
  startIcon,
  showChevron = true,
  collapseOnMobile = false,
  disabled,
  ariaLabel,
  className,
  ref,
  ...rest
}) => (
  <StyledTriggerButton
    {...rest}
    ref={ref}
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel ?? label}
    aria-expanded={open ?? rest['aria-expanded']}
    className={className}
    $size={size}
    $state={state}
    $collapseOnMobile={collapseOnMobile}
    data-applied={count > 0 ? true : undefined}
  >
    {startIcon && <StyledIconWrapper>{startIcon}</StyledIconWrapper>}
    <StyledTriggerButtonValue $size={size} data-trigger-text>
      <StyledValueText>{label}</StyledValueText>
      {count > 0 && (
        <StyledBadgeWrapper>
          <Badge label={String(count)} color="primary" size="sm" />
        </StyledBadgeWrapper>
      )}
    </StyledTriggerButtonValue>
    {showChevron && (
      <StyledTriggerButtonChevron $open={open} data-trigger-chevron>
        <ChevronDownIcon />
      </StyledTriggerButtonChevron>
    )}
  </StyledTriggerButton>
);

SelectTriggerButton.displayName = 'SelectTriggerButton';

export default SelectTriggerButton;
